import { apiClient } from "./client";

const apiGet = (endPoint, data = {}) => {
  return apiClient()
    .get(endPoint, data)
    .then((res) => {
      if (res?.status === 401) {
      }
      return res?.data;
    })
    .catch((err) => {
      return err?.message;
    });
};

const apiPost = (endPoint, data, headers = {}) => {
  return apiClient()
    .post(endPoint, data, {
      headers: {
        ...headers,
        "Content-Type": headers["Content-Type"] || "application/json",
      },
    })
    .then((res) => {
      if (res?.status === 401) {
      }
      return res;
    })
    .catch((err) => {
      console.log("API Post Error:", err);
      return {
        status: false,
        message:
          err?.response?.data || err?.message || "An unknown error occurred.",
      };
    });
};

const apiPut = (endPoint, data) => {
  return apiClient()
    .put(endPoint, data)
    .then((res) => {
      if (res?.status === 401) {
      }
      return res;
    })
    .catch((err) => {
      return err?.message;
    });
};

const apiDelete = (endPoint, data) => {
  return apiClient()
    .delete(
      endPoint,
      {},
      {
        data: data,
      }
    )
    .then((res) => {
      if (res?.status === 401) {
      }
      return res;
    })
    .catch((err) => {
      return err?.message;
    });
};

export { apiGet, apiPost, apiPut, apiDelete };
